import { Link } from "react-router-dom";
import { useBrand } from "../context/BrandContext";

const focusRingClass =
  "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rose-500";

function ServiceColumn({ title, items }) {
  return (
    <section className="min-w-0 border-t border-slate-200 py-5">
      <h2 className="text-base font-semibold text-slate-950">{title}</h2>
      <ul className="mt-3 space-y-2 text-sm leading-6 text-slate-600">
        {items.map((item) => (
          <li key={item} className="flex gap-2">
            <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-rose-500" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default function SalonBusinessCpaLanding() {
  const brand = useBrand();
  const loginUrl = brand?.opsLoginUrl || "https://ellyanna.com/login";

  return (
    <main className="min-h-screen bg-[#f8f6f4] text-slate-950">
      <header className="border-b border-slate-200 bg-white/90">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-4">
          <Link to="/" className="min-w-0 text-sm font-semibold text-slate-950">
            Ellyanna SalonBusinessCPA
          </Link>
          <a
            href={loginUrl}
            className={`inline-flex min-h-10 items-center justify-center rounded-full bg-rose-500 px-4 text-sm font-semibold text-white transition hover:bg-rose-600 ${focusRingClass}`}
          >
            Log in with Ellyanna
          </a>
        </div>
      </header>

      <section className="mx-auto grid min-h-[calc(100vh-74px)] max-w-6xl items-center gap-10 px-5 py-12 lg:grid-cols-[1.04fr_0.96fr]">
        <div>
          <p className="inline-flex rounded-full border border-rose-200 bg-white px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-rose-500">
            Ellyanna SalonBusinessCPA
          </p>
          <h1 className="mt-6 max-w-3xl text-4xl font-semibold leading-tight text-slate-950 md:text-6xl">
            Accounting, tax, payroll, and bookkeeping support for nail and beauty salons
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-600">
            Built for Canadian salon owners and independent professionals using Ellyanna Booking.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href={loginUrl}
              className={`inline-flex min-h-12 items-center justify-center rounded-full bg-rose-500 px-6 text-sm font-semibold text-white shadow-sm transition hover:bg-rose-600 ${focusRingClass}`}
            >
              Log in with Ellyanna
            </a>
            <a
              href="https://ellyanna.com"
              className={`inline-flex min-h-12 items-center justify-center rounded-full border border-slate-300 bg-white px-6 text-sm font-semibold text-slate-900 transition hover:border-slate-400 hover:bg-slate-50 ${focusRingClass}`}
            >
              Visit Ellyanna Booking
            </a>
          </div>
        </div>

        <div className="rounded-[28px] border border-white bg-white p-6 shadow-[0_24px_80px_rgba(47,53,102,0.12)]">
          <div className="grid gap-2 sm:grid-cols-2">
            <div className="rounded-2xl bg-rose-50 p-5">
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-rose-500">
                Salon ready
              </p>
              <p className="mt-3 text-2xl font-semibold text-slate-950">Canada-focused</p>
              <p className="mt-2 text-sm leading-6 text-slate-600">
                Practical support for salon workflows, service sales, staff pay, and owner tax planning.
              </p>
            </div>
            <div className="rounded-2xl bg-slate-100 p-5">
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
                Connected
              </p>
              <p className="mt-3 text-2xl font-semibold text-slate-950">Ellyanna Booking</p>
              <p className="mt-2 text-sm leading-6 text-slate-600">
                Designed to support operators already managing bookings, tickets, and reports in Ellyanna.
              </p>
            </div>
          </div>

          <div className="mt-6 grid gap-4 md:grid-cols-2">
            <ServiceColumn
              title="Accounting support"
              items={[
                "Bookkeeping cleanup and monthly review",
                "Payroll and contractor payment organization",
                "Sales, GST/HST, and tax liability preparation",
              ]}
            />
            <ServiceColumn
              title="Salon owner support"
              items={[
                "Owner-friendly reporting and year-end planning",
                "Independent professional business setup guidance",
                "Practical records support for growing salon teams",
              ]}
            />
          </div>
        </div>
      </section>
    </main>
  );
}
